import sticker from '@/components/sticker'

export default function(h) {
  return h(
    sticker,
    {
      props: this.$_props
    }
  )
}
